$(function () {
  'use strict';

  var $quicklinks = $('#quicklinks');

  // Early exit
  if(!$quicklinks.length) return;

  var $window = $(window);
  var $document = $(document);
  var is_displayed = false;
  var $target = $('#' + $quicklinks.data('target'));
  var $alwaysOn = $quicklinks.data('always-on') || false;

  var show = function() {
    $quicklinks.addClass('is-displayed');
    return true;
  };

  var hide = function() {
    $quicklinks.removeClass('is-displayed');
    return false;
  };

  if($target.length) {
    var observer;

    var build_threshold = function (num_steps) {
      var thresholds = [];

      for (var i=1.0; i<=num_steps; i++) {
        var ratio = i/num_steps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    };

    var handle_intersect = function(entries, observer) {
      entries.forEach(function(entry, index) {
        if(entry.intersectionRatio > 0 && is_displayed) {
          is_displayed = hide();
        } else if (entry.intersectionRatio == 0 && !is_displayed) {
          is_displayed = show();
        }
      });
    };

    var create_observer = function () {
      var options = {
        root: null,
        rootMargin: "0px",
        threshold: build_threshold(20)
      };

      observer = new IntersectionObserver(handle_intersect, options);
    };

    create_observer();
    observer.observe($target[0]);
  } else if ($alwaysOn) {
      is_displayed = show();
  } else {
    var has_scroll = true;

    var update = function () {
      if(has_scroll) {
        var scroll = $document.scrollTop();

        if(scroll > 100 && !is_displayed) {
          is_displayed = show();
        } else if(scroll <= 100 && is_displayed) {
          is_displayed = hide();
        }
      }

      has_scroll = false;
      window.requestAnimationFrame(update);
    };

    $window.on("scroll", function() {
      has_scroll = true;
    });

    update();
  }
});
